/* eslint-disable max-classes-per-file */

import { AppActionTypes } from "@app/store/actions/app.actions";
import { PayloadActionInterface } from "@app/store/actions/payload-action.interface";
import { Action } from "@ngrx/store";

export class FetchMessagesUnreadCount implements Action {
  readonly type = AppActionTypes.FETCH_MESSAGES_UNREAD_COUNT;
}

export class FetchMessagesUnreadCountSuccess implements PayloadActionInterface {
  readonly type = AppActionTypes.FETCH_MESSAGES_UNREAD_COUNT_SUCCESS;

  constructor(public payload: { count: number }) {}
}

export class FetchMessagesUnreadCountFailure implements PayloadActionInterface {
  readonly type = AppActionTypes.FETCH_MESSAGES_UNREAD_COUNT_FAILURE;

  constructor(public payload: { error: any }) {}
}
